const API_BASE_URL = "https://alcobrakeadmin.com/v3";

export const reportsAPI = {
  getOfficeInvoices: async (officeId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/us/cainvoices/getofficeinvoices?officeId=${officeId}`);
      if (!response.ok) throw new Error("Failed to fetch office invoices");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getOfficeFullClients: async (officeId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/us/fullclients/getofficefullclients?officeId=${officeId}`);
      if (!response.ok) throw new Error("Failed to fetch office clients");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getOfficeDevices: async (officeId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/us/cadevices/getofficedevices?officeId=${officeId}`);
      if (!response.ok) throw new Error("Failed to fetch office devices");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getUniqueDevice: async (sno) => {
    try {
      const response = await fetch(`${API_BASE_URL}/us/cadevices/getuniquedevice?sno=${sno}`);
      if (!response.ok) throw new Error("Failed to fetch unique device");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getAllLogs5: async (cbid, installDate) => {
    try {
      const response = await fetch(`${API_BASE_URL}/v2/eeprom/getalllogs5?cbid=${cbid}&installdate=${installDate}`);
      if (!response.ok) throw new Error("Failed to fetch eeprom logs");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  checkDealerUpdates: async (dealerId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/app/v2data/checkdealerupdates?dealerId=${dealerId}`);
      if (!response.ok) throw new Error("Failed to check dealer updates");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};
